/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface CreateOnboardingSignedUrlBody
 */
export interface CreateOnboardingSignedUrlBody {
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingSignedUrlBody
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof CreateOnboardingSignedUrlBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingSignedUrlBody
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingSignedUrlBody
     */
    lastName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOnboardingSignedUrlBody
     */
    wallets?: Array<string>;
    /**
     * The url to redirect the user to after they have completed the onboarding process. This should be passed in as a path with no domain (e.g. /merchants/64248455c0fbdce66f9a5962/ChIJzZ-ZyFd7K4cRPbfzaT_Q124 would redirect to a merchant page with the given path).
     * @type {string}
     * @memberof CreateOnboardingSignedUrlBody
     */
    redirectUrl?: string;
}

/**
 * Check if a given object implements the CreateOnboardingSignedUrlBody interface.
 */
export function instanceOfCreateOnboardingSignedUrlBody(value: object): value is CreateOnboardingSignedUrlBody {
    return true;
}

export function CreateOnboardingSignedUrlBodyFromJSON(json: any): CreateOnboardingSignedUrlBody {
    return CreateOnboardingSignedUrlBodyFromJSONTyped(json, false);
}

export function CreateOnboardingSignedUrlBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOnboardingSignedUrlBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'wallets': json['wallets'] == null ? undefined : json['wallets'],
        'redirectUrl': json['redirectUrl'] == null ? undefined : json['redirectUrl'],
    };
}

export function CreateOnboardingSignedUrlBodyToJSON(json: any): CreateOnboardingSignedUrlBody {
    return CreateOnboardingSignedUrlBodyToJSONTyped(json, false);
}

export function CreateOnboardingSignedUrlBodyToJSONTyped(value?: CreateOnboardingSignedUrlBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'wallets': value['wallets'],
        'redirectUrl': value['redirectUrl'],
    };
}

